import React from 'react';
import { faLinkedinIn } from '@fortawesome/free-brands-svg-icons';
import { faChevronLeft } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import './teamMemberInfo.css'
import { Modal } from 'react-bootstrap';
import FullMenu from '../../../main/components/fullmenu';
const MermberInfoModal = ({ setShow, show, teamInfo, isinvestment }) => {
    var link = '';
    if(teamInfo?.social_link) {
        link = teamInfo?.social_link[0]?.text;
    } else {
        link = teamInfo?.link[0]?.text;
    }

    return (
        <>

            <Modal
                show={show}
                centered
                fullscreen={true}
                onHide={() => setShow(false)}
                className="tm-modal"
                aria-labelledby="example-custom-modal-styling-title"
            >
                <Modal.Header >

                </Modal.Header>
                <Modal.Body closeButton>
                 
                    <section className="team-info-section section-common-info ">
                        {/* <style>{ProfileImg}</style> */}
                        <div className="profileimage  team-info-section ">
                            <div className="container ">
                                <h5 className="section-title  pb-4 pt-4" onClick={() => setShow(false)}>    <FontAwesomeIcon icon={faChevronLeft} className="back-btn " /> {!isinvestment ? "Visitors at ARTPARK" : "INVESTMENT COMMITTEE"} </h5>
                                {/* <h5 className="section-title  pb-4 pt-4" onClick={() => setShow(false)}>    <FontAwesomeIcon icon={faChevronLeft} className="back-btn " /> {!isinvestment ? "TEAM ARTPARK" : "INVESTMENT COMMITTEE"} </h5> */}

                                <div className="row team-member-info">
                                    <div className="mb-3"  style={{maxWidth:"100%"}}>
                                        <div className="row g-0 d-flex justify-content-between">
                                            <div className="col-md-6">
                                                <div className="card-body">
                                                    <h3 className="subtitle pt-0 pb-1">{teamInfo?.name[0]?.text}</h3>
                                                    <h5 className="body-text pb-4">{teamInfo?.designation[0]?.text}</h5>
                                                    <p className="body-text pb-2">{teamInfo?.about[0]?.text}</p>

                                                    {/* <a target="_blank" href={link} className="text-decoration-none">
                                                        <div className="  linkedin-btn row g-0">
                                                            <span className="col-3 d-flex justify-content-center" >
                                                                <FontAwesomeIcon icon={faLinkedinIn} />
                                                            </span>

                                                            <div className="  col-9 d-flex justify-content-center">
                                                                <p className=" p-0 m-0">View Linkedin Profile</p>
                                                            </div>



                                                        </div>
                                                    </a> */}


                                                </div>
                                            </div>
                                            <div className="col-md-6  d-flex justify-content-end d-none d-lg-block d-xl-block ">
                                                <img src={teamInfo?.img?.url} className="img-fluid rounded-start" alt="..."></img>
                                            </div>

                                        </div>
                                    </div>






                                    {/* <div className="col-md-5 ">

                                        <h3 className="subtitle pt-0 pb-1">{teamInfo?.name[0]?.text}</h3>
                                        <h5 className="body-text pb-4">{teamInfo?.designation[0]?.text}</h5>
                                        <p className="body-text pb-2">{teamInfo?.about[0]?.text}</p>

                                        <a target="_blank" href='' className="text-decoration-none">
                                            <div className="  linkedin-btn row g-0">
                                                <span className="col-3 d-flex justify-content-center" >
                                                    <FontAwesomeIcon icon={faLinkedinIn} />
                                                </span>

                                                <div className="  col-9 d-flex justify-content-center">
                                                    <p className=" p-0 m-0">View Linkedin Profile</p>
                                                </div>



                                            </div>
                                        </a>



                                    </div>
                                    <div className="col-md-7 ">

                                        <div className="  d-flex align-items-centert">
                                            <img src={teamInfo?.img?.url} className="card-img img-fluid" alt="..."></img>

                                        </div>
                                    </div>
 */}



                                </div>



                            </div>
                        </div>

                    </section>
                    <FullMenu />
                </Modal.Body>
            </Modal>
        </>


    );
};

export default MermberInfoModal;